function isEmptyObject(value) {
    return (
        value &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0
    );
}

function toFieldsObject(claimFields = []) {
    const fields = {};
    for (const row of claimFields) {
        if (!row || typeof row !== "object") continue;
        const name = row.name;
        if (!name) continue;
        fields[name] = row.value ?? "";
    }
    return fields;
}

function toTransactionsObject(claimTransactions = []) {
    const transactions = {};
    for (const row of claimTransactions) {
        if (!row || typeof row !== "object") continue;
        const itemId = row.item_id ?? row.itemId ?? null;
        const name = row.name;
        if (!itemId || !name) continue;
        const key = String(itemId);
        if (!transactions[key]) transactions[key] = {};
        transactions[key][name] = row.value ?? "";
    }
    return transactions;
}

function toFilesArray(claimFiles = []) {
    const files = [];
    for (const row of claimFiles) {
        if (!row || typeof row !== "object") continue;
        const storedName = row.filename || row.name;
        if (!storedName) continue;
        files.push({
            filename: storedName,
            name: storedName,
            description: row.description ?? "",
            filetype: row.filetype ?? "",
            failed: Boolean(row.failed),
            doc_id: row.form_id || row.doc_id || "submit-claim",
        });
    }
    return files;
}

export function capturePreservedClaimSections(claim) {
    const classMember = claim?.class_member;
    const claimId = classMember?.claim_id ?? claim?.data?.claim_id ?? null;
    if (!claimId) return;

    const claimFields = classMember?.claim_fields;
    const claimTransactions = classMember?.claim_transactions;
    const claimFiles = classMember?.claim_files;

    if (!Array.isArray(claimFields) && !Array.isArray(claimTransactions) && !Array.isArray(claimFiles)) {
        return;
    }

    claim.preservedClaimSections = {
        claim_id: claimId,
        fields: Array.isArray(claimFields) ? toFieldsObject(claimFields) : null,
        transactions: Array.isArray(claimTransactions)
            ? toTransactionsObject(claimTransactions)
            : null,
        files: Array.isArray(claimFiles) ? toFilesArray(claimFiles) : null,
    };
}

export function mergePreservedClaimSections(claim) {
    const preserved = claim?.preservedClaimSections;
    if (!preserved?.claim_id) return;

    if (!claim.data.claim_id) claim.data.claim_id = preserved.claim_id;

    if (preserved.fields) {
        if (!claim.data.fields || isEmptyObject(claim.data.fields)) {
            claim.data.fields = { ...preserved.fields };
        } else {
            for (const [key, value] of Object.entries(preserved.fields)) {
                if (!(key in claim.data.fields)) claim.data.fields[key] = value;
            }
        }
    }

    if (preserved.transactions) {
        if (
            !claim.data.transactions ||
            isEmptyObject(claim.data.transactions)
        ) {
            claim.data.transactions = JSON.parse(
                JSON.stringify(preserved.transactions)
            );
        } else {
            for (const [itemId, row] of Object.entries(preserved.transactions)) {
                if (!claim.data.transactions[itemId]) {
                    claim.data.transactions[itemId] = { ...row };
                    continue;
                }
                for (const [key, value] of Object.entries(row)) {
                    if (!(key in claim.data.transactions[itemId])) {
                        claim.data.transactions[itemId][key] = value;
                    }
                }
            }
        }
    }
}
